<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div class="pa-1">
        <div style="width:100%; padding-top:10px; padding-bottom:10px" class="grey lighten-4">
            <span class="font-weight-regular" style="margin-left:10px" >■システム管理者用設定画面</span>
        </div>
        <!-- <v-btn @click="onClickWork1">所属グループ対応</v-btn> -->
        <!-- <v-btn @click="onClickWork2">システム通知対応</v-btn> -->
        <!-- <v-btn @click="onClickWork3">栽培区分テンプレート作成</v-btn> -->
        <!-- <v-btn @click="onClickWork4">作業項目、肥料等のテンプレート作成</v-btn> -->
        <!-- <v-btn @click="onClickWork5">気象データの移動</v-btn> -->
        <!-- <v-btn @click="onClickWork6">地域データの移動</v-btn> -->
        <!-- <v-btn @click="onClickRegistSicks" class="ma-1" color="primary">病気データの登録</v-btn> -->
        <!-- <v-btn @click="onClickRegistVermins" class="ma-1" color="primary">害虫データの登録</v-btn> -->
        <!-- <v-btn @click="onClickRegistBaseAgrichemicals" class="ma-1" color="primary">農薬基礎データの登録</v-btn> -->
        <!-- <v-btn @click="onClickRegistAgrichemicals_asparagus" class="ma-1" color="primary">農薬データ(アスパラガス)の登録</v-btn> -->
        <!-- <v-btn @click="onClickRegistAgrichemicals_broccoli" class="ma-1" color="primary">農薬データ(ブロッコリー)の登録</v-btn> -->
        <!-- <v-btn @click="onClickAddItemToPlace" class="ma-1" color="primary">場所データへの新規項目を追加</v-btn> -->
        <!-- <v-btn @click="onClickModifyGroupData" class="ma-2" color="primary">グループデータの更新</v-btn> -->
        <v-btn @click="onClickRegistBox" class="ma-2" color="primary">BOXデータの登録</v-btn>
        <v-card class="pa-2" flat>
            <v-tabs
                v-model="currentTabIndex"
                >
                <v-tab v-for="item in settingItems" :key="item.tab">
                    <v-chip v-if="currentTabIndex == item.index" color="green lighten-4" label>
                        <v-icon>{{item.icon}}</v-icon>
                        {{item.tab}}                    
                    </v-chip>
                    <span v-else>
                        <v-icon>{{item.icon}}</v-icon>
                        {{item.tab}}
                    </span>
                </v-tab>
                <v-tab-item><UserList /></v-tab-item>
                <v-tab-item><Notification /></v-tab-item>
                <v-tab-item><Area /></v-tab-item>
                <v-tab-item><Restore /></v-tab-item>
                <v-tab-item><License /></v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import UserList from '@/components/setting/items/SystemManagerUserList'
    import Notification from '@/components/setting/items/SystemManagerNotification'
    import Area from '@/components/setting/items/SystemManagerArea'
    import Restore from '@/components/setting/items/SystemManagerRestore'
    import License from '@/components/setting/items/SystemManagerLicense'
    export default {
        components: {
            UserList,
            Notification,
            Area,
            Restore,
            License,
        },
        data: function() {
            return {
                currentTabIndex: 0,
                settingItems: [
                    {tab:"ユーザー一覧", index:0, icon:""},
                    {tab:"通知", index:1, icon:""},
                    {tab:"地域", index:2, icon:""},
                    {tab:"データ復元", index:3, icon:""},
                    {tab:"ライセンス管理", index:4, icon:""},
                ]
            }
        },
        methods: {
            onClickRegistBox: function () {
                const box = {
                    boxIdentificationCode: "000-00001",
                    userUID: "Ffffq7b9cpUsotRcnKfJwQhW7F12",
                    sensors: [
                        {
                            sensorKey: "001",
                            type: 1,
                            typeData: {id: "28-3c01b607ac3d"},
                            name: "温度-1",
                            measureInterval: 60000,
                            unit: "℃",
                            min: -10,
                            max: 85,
                            alarms: {
                                measure: {
                                    min: {
                                        enabled: true,
                                        value: 22,
                                        durationTime: 5
                                    },
                                    max: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    nextAlarmInterval: 10
                                },
                                abnormal: {
                                    watchRange: 5,
                                    num: 4,
                                    enabled: true,
                                    nextAlarmInterval: 10
                                },
                            },
                        },
                        {
                            sensorKey: "002",
                            type: 1,
                            typeData: {id: "28-3c01b607bb32"},
                            name: "温度-2",
                            measureInterval: 60000,
                            unit: "℃",
                            min: -10,
                            max: 85,
                            alarms: {
                                measure: {
                                    min: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    max: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    nextAlarmInterval: 0
                                },
                                abnormal: {
                                    watchRange: 5,
                                    num: 4,
                                    enabled: true,
                                    nextAlarmInterval: 10
                                },
                            },
                        },
                        {
                            sensorKey: "003",
                            type: 1,
                            typeData: {id: "28-3c01b607c2ce"},
                            name: "温度-3",
                            measureInterval: 60000,
                            unit: "℃",
                            min: -10,
                            max: 85,
                            alarms: {
                                measure: {
                                    min: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    max: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    nextAlarmInterval: 0
                                },
                                abnormal: {
                                    watchRange: 5,
                                    num: 4,
                                    enabled: true,
                                    nextAlarmInterval: 10
                                },
                            },
                        },
                        {
                            sensorKey: "004",
                            type: 1,
                            typeData: {id: "28-3c01b607d143"},
                            name: "温度-4",
                            measureInterval: 60000,
                            unit: "℃",
                            min: -10,
                            max: 85,
                            alarms: {
                                measure: {
                                    min: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    max: {
                                        enabled: false,
                                        value: 0,
                                        durationTime: 0
                                    },
                                    nextAlarmInterval: 0
                                },
                                abnormal: {
                                    watchRange: 5,
                                    num: 4,
                                    enabled: true,
                                    nextAlarmInterval: 10
                                },
                            },
                        },
                    ],
                    aliveAlarm: {
                        durationTime: 5,
                        enabled: true,
                        nextAlarmInterval: 60
                    },
                    notification: {
                        type: 1,
                        data: {
                            callTime: 30,
                            reCallInterval: 60,
                            reNum: 3
                        }
                    }
                }
                db.collection("environments").doc(box.boxIdentificationCode).delete().then(function(){
                    db.collection("environments").doc(box.boxIdentificationCode).set(box).then(function(){
                        console.log("registered box")
                    }).catch (function(error){
                        console.log("regist box failed", error)
                    })
                })
            },
            onClickModifyGroupData: function () {
                const self = this
                db.collection("users").get().then(function(refUsers){
                    refUsers.forEach(function(docUser){
                        const user = docUser.data()
                        db.collection("users").doc(user.userUID).collection("groups").get().then(function(refGroups){
                            refGroups.forEach(function(docGroup){
                                const group = docGroup.data()
                                if (group.version == "1.0.0") {
                                    const newGroup = {
                                        version: "2.0.0",
                                        onwerUserUID: user.userUID,
                                        groupNo: group.groupNo,
                                        groupName: group.groupName,
                                        registeredDateTime: group.registeredDateTime,
                                        updatedDateTime: group.updatedDateTime
                                    }
                                    db.collection("users").doc(user.userUID).collection("groups").doc(newGroup.groupNo+"").set(newGroup)
                                    console.log("new group registered!!", newGroup)
                                }
                            })
                        })
                        db.collection("users").doc(user.userUID).collection("belong_groups").get().then(function(refGroups){
                            refGroups.forEach(function(docGroup){
                                const id = docGroup.id
                                const group = docGroup.data()
                                if (group.version == "1.0.0") {
                                    const newGroup = {
                                        version: "2.0.0",
                                        onwerUserUID: group.owner.userUID,
                                        groupNo: group.groupNo,
                                        registeredDateTime: group.registeredDateTime,
                                        updatedDateTime: group.updatedDateTime
                                    }
                                    db.collection("users").doc(user.userUID).collection("belong_groups").doc(id).set(newGroup)
                                    console.log("new belong group registered!!", id, newGroup)
                                }
                            })
                        })
                    })
                })
            },
            onClickAddItemToPlace: function () {
                db.collection("users").get().then(function(refUsers){
                    refUsers.forEach(function(docUser){
                        const user = docUser.data()
                        db.collection("users").doc(user.userUID).collection("places").get().then(function(refPlaces){
                            refPlaces.forEach(function(docPlace){
                                const place = docPlace.data()
                                var needUpdate = false
                                if (place.groupUserAuthorities == null) {
                                    place.groupUserAuthorities = ["browse", "work", "environment"]
                                    needUpdate = true
                                }
                                if (place.managementAgrichemical == null) {
                                    place.managementAgrichemical = {
                                        enabled: false,
                                        target: null,
                                        dateTime: "",
                                        startDate: {
                                            month: 1,
                                            day: 1
                                        }
                                    }
                                    needUpdate = true
                                }
                                if (needUpdate) {
                                    db.collection("users").doc(user.userUID).collection("places").doc(place.placeID+"").set(place)
                                    console.log(user.userUID, place)
                                }
                            })
                        })
                    })
                })
            },
            onClickRegistSicks: function () {
                const sicks = [
                    {version: '1.0.0', sickNo:1,name:'菌核病',memo:''},
                    {version: '1.0.0', sickNo:2,name:'べと病',memo:''},
                    {version: '1.0.0', sickNo:3,name:'黒腐病',memo:''},
                    {version: '1.0.0', sickNo:4,name:'軟腐病',memo:''},
                    {version: '1.0.0', sickNo:5,name:'黒斑細菌病',memo:''},
                    {version: '1.0.0', sickNo:6,name:'花蕾腐敗病',memo:''},
                    {version: '1.0.0', sickNo:7,name:'黒すす病',memo:''},
                    {version: '1.0.0', sickNo:8,name:'根こぶ病',memo:''},
                    {version: '1.0.0', sickNo:9,name:'茎枯病',memo:''},
                    {version: '1.0.0', sickNo:10,name:'斑点病',memo:''},
                    {version: '1.0.0', sickNo:11,name:'褐斑病',memo:''},
                    {version: '1.0.0', sickNo:12,name:'立枯病',memo:''},
                    {version: '1.0.0', sickNo:13,name:'株腐病',memo:''},
                ]
                const sicksData = {
                    version: "1.0.0",
                    list: {}
                }

                for (var i=0; i<sicks.length; i++) {
                    sicksData.list[sicks[i].sickNo] = {
                        sickNo: sicks[i].sickNo,
                        name: sicks[i].name,
                        memo: sicks[i].memo,
                    }
                }
                db.collection("system").doc("template").collection("sicks").doc("data").set(sicksData)
            },
            onClickRegistVermins: function () {
                const vermins = [
                    {version: '1.0.0', verminNo:1,name:'アブラムシ類',memo:''},
                    {version: '1.0.0', verminNo:2,name:'アザミウマ類',memo:''},
                    {version: '1.0.0', verminNo:3,name:'ネギアザミウマ',memo:''},
                    {version: '1.0.0', verminNo:4,name:'コナジラミ類',memo:''},
                    {version: '1.0.0', verminNo:5,name:'ハスモンヨトウ',memo:''},
                    {version: '1.0.0', verminNo:6,name:'ヨトウムシ',memo:''},
                    {version: '1.0.0', verminNo:7,name:'オオタバコガ',memo:''},
                    {version: '1.0.0', verminNo:8,name:'ハダニ類',memo:''},
                    {version: '1.0.0', verminNo:9,name:'ジュウシホシクビナガハムシ',memo:''},
                    {version: '1.0.0', verminNo:10,name:'カメムシ類',memo:''},
                    {version: '1.0.0', verminNo:11,name:'アオムシ',memo:''},
                    {version: '1.0.0', verminNo:12,name:'コナガ',memo:''},
                    {version: '1.0.0', verminNo:13,name:'ウワバ類',memo:''},
                    {version: '1.0.0', verminNo:14,name:'ハイマダラノメイガ',memo:''},
                ]
                const verminsData = {
                    version: "1.0.0",
                    list: {}
                }

                for (var i=0; i<vermins.length; i++) {
                    verminsData.list[vermins[i].verminNo] = {
                        verminNo: vermins[i].verminNo,
                        name: vermins[i].name,
                        memo: vermins[i].memo,
                    }
                }
                db.collection("system").doc("template").collection("vermins").doc("data").set(verminsData)
            },
            onClickRegistBaseAgrichemicals: function () {
                const items = [
                    {
                        version: "1.0.0",
                        target: 1,
                        targetName: "アスパラガス",
                        mixInfo: [
                            {value: 0, mark:"事例なし", text: "混用事例なし", color:"red", canMix: false},
                            {value: 1, mark:"◎", text: "現地混用事例が２つあり、いずれも問題なかった。 また、メーカーの混用事例で問題なし", color:"black", canMix: true},
                            {value: 2, mark:"○", text: "現地混用事例が１つあり、問題なかった", color:"black", canMix: true},
                            {value: 3, mark:"△", text: "薬害発生の事例はあったが、問題なしの事例が多い", color:"blue", canMix: true},
                            {value: 4, mark:"☓", text: "薬害発生の事例のみ", color:"red", canMix: false},
                        ],
                        source: "JA全農ふくれん 2020年6月 アスパラガス農薬混用事例集",
                        memo: ""
                    },
                    {
                        version: "1.0.0",
                        target: 2,
                        targetName: "ブロッコリー",
                        mixInfo: [
                            {value: 0, mark:"事例なし", text: "混用事例なし", color:"red", canMix: false},
                            {value: 1, mark:"○", text: "混用してよい", color:"black", canMix: true},
                            {value: 2, mark:"◎", text: "使用直前の混用なら問題ない", color:"black", canMix: true},
                            {value: 3, mark:"▲", text: "薬害の点で問題がある", color:"blue", canMix: true},
                            {value: 4, mark:"☓", text: "混用できない", color:"red", canMix: false},
                        ],
                        source: "JA全農ふくれん 令和2年7月 ブロッコリー農薬混用事例集",
                        memo: ""
                    },
                ]

                for (var i=0; i<items.length; i++) {
                    db.collection("system").doc("template").collection("agrichemicals").doc(items[i].target+"").set(items[i])
                }
            },
            onClickRegistAgrichemicals_asparagus: function () {
                const items = [
                    {version:'1.0.0', target:1, agrichemicalNo:1, name:'コサイド3000', strain:'銅',classificationCode:'M1',dilution:{min:null,max:2000},useTime:{type:null,value:null},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:0,sicks:[9,10,11],vermins:[], memo:'高温時薬害注意',mixList:[0,,,,2,1,,1,1,1,1,,,2,1,1,,1,1,1,1,2,1,1,2,2,,1,1,2,1,1,1,1,1,1,,1,1,1,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:2, name:'Zボルドー', strain:'銅',classificationCode:'M1',dilution:{min:null,max:500},useTime:{type:null,value:null},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:0,sicks:[9,10],vermins:[], memo:'高温時薬害注意、シグナムWDGとは直前混用ならば問題なし',mixList:[0,,,1,,,,,,1,,,,2,2,2,,1,1,1,,,,2,,2,,1,,1,1,,,1,1,1,,1,1,,,1,,4,2,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:3, name:'アミスター２０フロアブル', strain:'スト',classificationCode:'11',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:4,sicks:[9,10,11],vermins:[], memo:'高温時薬害注意・展着剤不可',mixList:[0,,1,,,1,,1,,1,,,,,1,1,,1,1,1,1,,,1,1,1,2,4,1,1,1,,1,1,3,3,,1,1,1,2,1,,1,4,4,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:4, name:'ストロビーフロアブル', strain:'スト',classificationCode:'11',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:3,sicks:[10],vermins:[], memo:'高温時薬害注意・展着剤不可',mixList:[0,2,,,,1,,2,,1,,,,,4,,1,1,1,1,2,,,1,1,1,1,4,,1,1,,,1,1,1,,2,,1,2,2,1,1,,4,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:5, name:'シグナムWDG', strain:'スト+他',classificationCode:'11',dilution:{min:null,max:1500},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:2,sicks:[9,10,11],vermins:[], memo:'カスケードとは直前の混用なら問題なし。ウララDFとは凝集するが撹拌すれば問題なし',mixList:[0,1,,1,1,,,1,1,1,1,1,,,1,1,1,1,1,1,1,1,1,1,2,2,,1,2,1,1,1,1,1,1,1,,1,1,1,1,1,,,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:6, name:'ファンタジスタ顆粒水和剤', strain:'他',classificationCode:'11',dilution:{min:null,max:3000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[9,10,11],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,1,1,,1,1,1,1,,1,1,1,,,,1,,1,,,1,1,1,,1,,1,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:7, name:'ダコニール１０００', strain:'有塩',classificationCode:'M5',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'400'},useLimitNum:4,sicks:[9,10,11],vermins:[], memo:'疫病',mixList:[0,1,,1,2,1,,,,1,,,,,1,3,1,1,1,1,1,2,,1,1,1,1,1,1,1,1,1,1,1,1,1,,1,,1,1,1,1,4,,1,,1,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:8, name:'ベンレート水和剤', strain:'ベン',classificationCode:'1',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:4,sicks:[9,13],vermins:[], memo:'',mixList:[0,1,,,,1,,,,1,,,,,3,4,,1,1,1,1,2,2,1,3,1,2,1,1,1,1,,1,1,1,1,,1,,1,1,1,1,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:9, name:'アフェットフロアブル', strain:'他',classificationCode:'7',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:4,sicks:[9,10,11],vermins:[], memo:'',mixList:[0,1,1,1,1,1,,1,1,,1,,,,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,,1,1,1,1,1,1,,1,1,2,,,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:10, name:'ロブラール水和剤', strain:'他',classificationCode:'2',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:5,sicks:[9,10],vermins:[], memo:'',mixList:[0,1,,,,1,,,,1,,,,,2,1,,1,1,1,1,1,2,1,1,1,2,1,1,1,1,,1,1,1,1,,1,,1,2,1,,,,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:11, name:'ラリー水和剤', strain:'EB',classificationCode:'3',dilution:{min:null,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'150',max:'300'},useLimitNum:2,sicks:[10],vermins:[], memo:'',mixList:[0,,,,,1,,,,,,,,,,2,,1,2,2,1,,,2,,2,,,,2,2,,1,2,2,2,,2,,2,2,2,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:12, name:'スコア顆粒水和剤', strain:'他',classificationCode:'3(G1)',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'200',max:'500'},useLimitNum:2,sicks:[10],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:13, name:'メジャーフロアブル', strain:'他',classificationCode:'11(C3)',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[9,10],vermins:[], memo:'',mixList:[0,2,2,,,,,,,,,,,,2,2,,2,2,2,2,,2,,,,,,2,2,2,,,2,2,2,,2,,2,2,2,,,,,,,2,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:14, name:'アディオン乳剤', strain:'ピレ',classificationCode:'3A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[1,6,9,10], memo:'ジュウシホシクビナガハムシ、カメムシ類2000～3000倍',mixList:[0,1,2,1,4,1,1,1,3,1,2,,,2,,,,2,,1,,,,1,1,1,,1,,,2,1,1,1,1,1,,1,1,1,,1,,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:15, name:'アーデント水和剤', strain:'ピレ',classificationCode:'3A',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'150',max:'500'},useLimitNum:2,sicks:[],vermins:[1,7,10], memo:'',mixList:[0,1,2,1,,1,1,3,4,1,1,2,,2,,,,1,2,1,,,,1,1,1,,1,,2,1,,1,1,1,2,,1,1,,,1,1,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:16, name:'スカウトフロアブル', strain:'ピレ',classificationCode:'3A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[6], memo:'劇物',mixList:[0,,,,1,1,,1,,1,,,,,,,,1,,1,,,,,,,,,,,,,,,1,,,1,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:17, name:'モスピラン顆粒水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:null,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[1,2,4,9,10], memo:'劇物',mixList:[0,1,1,1,1,1,1,1,1,1,1,1,,2,2,1,1,,,,2,,,1,2,2,,1,1,,2,,1,1,1,1,,1,1,1,1,1,,2,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:18, name:'ダントツ水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[1,3,9,10], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,2,,2,,2,,,,1,,,,1,1,1,,,,,,,1,1,1,2,,1,1,1,2,1,,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:19, name:'スタークル顆粒水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'800'},useLimitNum:3,sicks:[],vermins:[2,4,9,10], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,2,,2,1,1,1,,1,,1,,1,1,1,1,1,,1,,1,,,1,1,1,,1,,2,1,,,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:20, name:'アドマイヤー顆粒水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:null,max:5000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[2], memo:'劇物',mixList:[0,1,,1,2,1,1,1,1,1,1,1,,2,,,,2,,1,,,,1,,1,,,,,,,1,1,2,2,,1,1,,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:21, name:'ベストガード水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[4], memo:'',mixList:[0,2,,,,1,,2,2,2,1,,,,,,,,,,,,,,2,,,,,,,,,,,,,1,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:22, name:'アクラタ顆粒水溶剤', strain:'ネオ',classificationCode:'4A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[3], memo:'',mixList:[0,1,,,,1,1,,2,1,2,,,2,,,,,,1,,,,,,1,,,,,,,,1,,,,1,1,1,,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:23, name:'カスケード乳剤', strain:'IG',classificationCode:'15',dilution:{min:null,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:2,sicks:[],vermins:[2,5,7], memo:'',mixList:[0,1,2,1,1,1,1,1,1,1,1,2,,,1,1,,1,1,1,1,,,,2,,1,1,1,2,1,1,1,1,1,1,,1,1,1,2,1,1,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:24, name:'ノーモルト乳剤', strain:'IG',classificationCode:'15',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[5], memo:'',mixList:[0,2,,1,1,2,1,1,3,1,1,,,,1,1,,2,1,1,,2,,2,,1,3,1,,2,1,1,,1,1,3,,,,,,2,1,1,,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:25, name:'カウンター乳剤', strain:'IG',classificationCode:'15',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[5,7], memo:'',mixList:[0,2,2,1,1,2,,1,1,1,1,2,,,1,1,,2,1,1,1,,1,,1,,,,2,1,1,,1,1,,1,,,,2,1,2,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:26, name:'デルフィン顆粒水溶剤', strain:'BT',classificationCode:'11A',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:0,sicks:[],vermins:[5,7], memo:'野菜類で登録、発生初期、シロイチモジヨトウ',mixList:[0,,,2,1,,,1,2,1,2,,,,,,,,,1,,,,1,3,,,1,,,,,,2,2,,,,,,,,,1,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:27, name:'ハチハチフロアブル', strain:'他',classificationCode:'21A',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'800'},useLimitNum:2,sicks:[],vermins:[1,3,4,9], memo:'劇物、ツマグロアオカスミカメ',mixList:[0,1,1,4,4,1,,1,1,1,1,,,,1,1,,1,,,,,,1,1,,1,,,,1,,1,1,1,1,,1,1,,1,,,,,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:28, name:'ウララDF', strain:'他',classificationCode:'29',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[1,3], memo:'',mixList:[0,1,,1,,2,1,1,1,1,1,,,2,,,,1,,1,,,,1,,2,,,,,1,,,,1,1,,1,,2,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:29, name:'ディアナSC', strain:'他',classificationCode:'5',dilution:{min:2500,max:5000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:2,sicks:[],vermins:[2,4,5,7,9], memo:'コナジラミ類2500倍',mixList:[0,2,1,1,1,1,,1,1,1,1,2,,2,,2,,,,,,,,2,2,1,,,,,,,1,,1,,,,1,,1,,,,,1,,1,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:30, name:'スピノエース顆粒水溶剤', strain:'他',classificationCode:'5',dilution:{min:null,max:5000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[2], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,2,,2,2,1,,2,,1,,,,1,1,1,,1,1,,,,1,1,1,1,,1,1,1,2,1,1,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:31, name:'リーフガード顆粒水溶剤', strain:'他',classificationCode:'14',dilution:{min:null,max:1500},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[2], memo:'',mixList:[0,1,,,,1,,1,,,,,,,1,,,,,,,,,1,1,,,,,,,,,,1,1,,,,,1,,,,,,1,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:32, name:'モベントフロアブル', strain:'他',classificationCode:'23',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[2,4,8], memo:'',mixList:[0,1,,1,,1,,1,1,1,1,1,,,1,1,,1,1,,1,,,1,,1,,1,,1,1,,,1,1,1,,1,,1,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:33, name:'プレオフロアブル', strain:'他',classificationCode:'UN',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[3,5,6,7], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,2,,2,1,1,,1,1,1,1,,1,1,1,1,2,1,,,1,,1,,1,1,,,,1,1,1,,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:34, name:'コテルフロアブル', strain:'他',classificationCode:'13',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:2,sicks:[],vermins:[5,6,7,8,9], memo:'劇物',mixList:[0,1,1,3,1,1,1,1,1,1,1,2,,2,1,1,1,1,1,1,2,,,1,1,,2,1,1,1,1,1,1,1,,1,,1,1,1,2,1,1,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:35, name:'アファーム乳剤', strain:'他',classificationCode:'6',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[5,6,7], memo:'',mixList:[0,1,1,3,1,1,1,1,1,1,1,2,,2,1,2,,1,2,1,2,,,1,3,1,,1,1,,1,1,1,1,1,,,1,1,1,2,1,1,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:36, name:'アニキ乳剤', strain:'他',classificationCode:'6',dilution:{min:null,max:null},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[4,5], memo:'コナジラミ類1000倍、ハスモンヨトウ2000倍',mixList:[0,,,,,,,,,1,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:37, name:'フェニックス顆粒水溶剤', strain:'ジア',classificationCode:'28',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[5,6,7], memo:'ハスモンヨトウ2000倍',mixList:[0,1,1,1,2,1,1,1,1,1,1,2,,2,1,1,1,1,1,1,1,1,1,1,,,,1,1,,1,,1,,1,1,,,,,1,1,,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:38, name:'アクセルフロアブル', strain:'他',classificationCode:'22B',dilution:{min:1000,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'800'},useLimitNum:3,sicks:[],vermins:[5], memo:'',mixList:[0,1,1,1,,1,,,,,,,,,1,1,,1,1,,1,,1,1,,,,1,,1,1,,,,1,1,,,,,1,1,,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:39, name:'プレバソンフロアブル５', strain:'ジア',classificationCode:'28',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[5], memo:'',mixList:[0,1,,1,1,1,1,1,1,1,1,2,,2,1,,,1,1,2,,,1,1,,2,,,2,,1,,1,1,1,1,,,,,1,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:40, name:'コロマイト乳剤', strain:'他',classificationCode:'6',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:2,sicks:[],vermins:[8], memo:'',mixList:[0,1,,2,2,1,1,1,1,1,2,2,,2,,,,1,2,1,1,,,2,,1,,1,,1,2,1,1,1,2,2,,1,1,1,,1,,1,1,1,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:41, name:'コルト顆粒水溶剤', strain:'他',classificationCode:'9B',dilution:{min:null,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'700'},useLimitNum:3,sicks:[],vermins:[3,4], memo:'カスミカメムシ類',mixList:[0,1,1,1,2,1,1,1,1,2,1,2,,2,1,1,,1,1,,1,,1,1,2,2,,,,,1,,1,1,1,1,,1,1,,1,,,1,1,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:42, name:'ダニサラバフロアブル', strain:'他',classificationCode:'25A',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:2,sicks:[],vermins:[8], memo:'',mixList:[0,,,,1,,,1,1,,,,,,,1,,,,,,,,1,1,,,,,,1,,,,1,1,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:43, name:'エコピタ液剤', strain:'他',classificationCode:'',dilution:{min:null,max:100},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:0,sicks:[],vermins:[1,4,8], memo:'野菜類で登録',mixList:[0,,4,1,1,,,4,1,,,,,,1,1,,2,1,1,,,,1,1,,1,,,,1,,,1,1,1,,1,1,,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:44, name:'サンクリスタル乳剤', strain:'他',classificationCode:'',dilution:{min:null,max:300},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:0,sicks:[],vermins:[1,4,8], memo:'野菜類で登録。ハダニ類は300～600倍。薬害注意',mixList:[0,,2,4,,1,,,1,1,,,,,1,1,,1,1,1,,,,1,,,,,,,1,,,1,1,1,,1,1,,1,1,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:45, name:'オレート液剤', strain:'他',classificationCode:'',dilution:{min:null,max:100},useTime:{type:99,value:'発生初期～収穫前日まで'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:0,sicks:[],vermins:[1,4], memo:'野菜類で登録。コナジラミ類は100～300倍。薬害注意',mixList:[0,,,4,4,1,,1,1,1,1,,,,,,,,1,1,,,,1,1,,,1,,1,1,,,1,,1,,,,,1,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:46, name:'フーモン', strain:'他',classificationCode:'',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'150',max:'500'},useLimitNum:0,sicks:[],vermins:[1,4,8], memo:'野菜類で登録',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,1,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:47, name:'ベネビアOD', strain:'ジア',classificationCode:'28',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'300'},useLimitNum:3,sicks:[],vermins:[2,5], memo:'アザミウマ類2000倍、ハスモンヨトウ4000倍',mixList:[0,,,,,,,1,,,,,,,,,,,,,,,,,,,,,,1,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:48, name:'ダニコングフロアブル', strain:'他',classificationCode:'25B',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'700'},useLimitNum:2,sicks:[],vermins:[8], memo:'',mixList:[0,,,,,,,,,,,,,2,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:49, name:'マイトコーネフロアブル', strain:'他',classificationCode:'20D',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:1,sicks:[],vermins:[8], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:50, name:'スターマイトフロアブル', strain:'他',classificationCode:'25A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:1,sicks:[],vermins:[8], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:145, name:'ガードベイトA', strain:'ピレ',classificationCode:'3A',dilution:{min:null,max:null},useTime:{type:1,value:'1'},prevarication:{unit:'10a', min:null,max:'3kg'},useLimitNum:3,sicks:[],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:146, name:'トリフミン水和剤', strain:'EB',classificationCode:'3',dilution:{min:null,max:1000},useTime:{type:1,value:'7'},prevarication:{unit:'10a', min:null,max:'3L/m3'},useLimitNum:1,sicks:[12],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:147, name:'ベルクート水和剤', strain:'他',classificationCode:'M7',dilution:{min:null,max:1000},useTime:{type:1,value:'7'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:5,sicks:[9,10,11],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:1, agrichemicalNo:148, name:'トップジン水和剤', strain:'ベン',classificationCode:'1',dilution:{min:null,max:1000},useTime:{type:99,value:'収穫開始７日前まで'},prevarication:{unit:'10a', min:'100',max:'500'},useLimitNum:5,sicks:[9,12],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                ]
                for (var i=0; i<items.length; i++) {
                    const mixList = {}
                    for (var j=1; j<items[i].mixList.length; j++) {
                        if (items[i].mixList[j] == null) {
                            // mixList[j] = 0
                        } else {
                            mixList[j] = items[i].mixList[j]
                        }
                    }
                    items[i].mixList = mixList
                    db.collection("system").doc("template").collection("agrichemicals").doc(items[i].target+"").collection("items").doc(items[i].agrichemicalNo+"").set(items[i])
                }
            },
            onClickRegistAgrichemicals_broccoli: function () {
                const items = [
                    {version:'1.0.0', target:2, agrichemicalNo:1, name:'アクセルフロアブル', strain:'',classificationCode:'22B',dilution:{min:1000,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[12,6,5], memo:'コナガは希釈倍率1000',mixList:[0,,1,,,1,,1,1,1,1,,,,,,1,1,1,1,1,,,1,1,1,,1,1,1,1,1,1,1,1,,1,,1,,1,,,1,1,1,1,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:2, name:'アニキ乳剤', strain:'',classificationCode:'6',dilution:{min:1000,max:2000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12,5], memo:'',mixList:[0,1,,1,,,,1,1,1,1,,,1,,,,1,,,,,,,1,1,1,1,,,1,1,1,1,1,1,1,1,1,,1,,,1,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:3, name:'アファーム乳剤', strain:'',classificationCode:'6',dilution:{min:1000,max:2000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12,6], memo:'',mixList:[0,,1,,1,1,,1,1,1,,,,,,1,,1,1,1,1,,,1,1,,1,1,1,,1,,1,1,,1,1,1,1,1,1,,,,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:4, name:'エスマルクDF', strain:'',classificationCode:'11A',dilution:{min:1000,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[],vermins:[11,12,6,7], memo:'ヨトウムシ・オオタバコガは希釈倍率1000',mixList:[0,,,1,,,,,,1,,,,,,,,,,1,,,,1,,,1,1,,,,1,,1,,,1,,,,,,,,4,,,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:5, name:'カスケード乳剤', strain:'',classificationCode:'15',dilution:{min:null,max:4000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[11,12,5,2], memo:'',mixList:[0,1,,1,,,,1,1,1,1,,,,,1,1,1,,,1,,,1,1,1,1,,1,2,1,,2,1,,1,1,2,,1,1,,,,1,,,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:6, name:'グレーシア乳剤', strain:'',classificationCode:'30',dilution:{min:2000,max:3000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[11,12,6,5,14,2,7,13], memo:'',mixList:[0,,,,,,,,1,1,,,1,,,,,,,,,1,,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,4,1,,,4,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:7, name:'コテツフロアブル', strain:'',classificationCode:'13',dilution:{min:null,max:2000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[11,12,6,5], memo:'',mixList:[0,1,1,1,,1,,,1,1,,,,,,1,1,1,1,1,1,,,1,1,,1,1,1,1,,,1,1,,1,1,1,1,1,1,,,1,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:8, name:'コルト顆粒水溶剤', strain:'',classificationCode:'9B',dilution:{min:null,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[1], memo:'',mixList:[0,1,1,1,,1,1,1,,,1,,,,,,1,1,1,1,1,,,1,,1,,1,1,1,1,1,1,1,1,,1,1,,,,,,,1,1,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:9, name:'スタークル顆粒水和剤', strain:'',classificationCode:'4A',dilution:{min:2000,max:3000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[1], memo:'',mixList:[0,1,1,1,1,1,1,1,,,1,,,,,,,1,1,1,1,,1,,,,1,1,1,1,,,1,1,,,1,1,,1,1,,,,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:10, name:'スピノエース顆粒水溶剤', strain:'',classificationCode:'5',dilution:{min:null,max:5000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12], memo:'',mixList:[0,1,1,,,1,,,1,1,,,,,,,1,1,1,1,,,,,1,,1,1,1,1,1,,1,1,,1,1,1,1,1,1,,,,1,1,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:11, name:'ディアナSC', strain:'',classificationCode:'5',dilution:{min:2500,max:5000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[11,12,6,5,14,2,7,13], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,1,1,1,1,,,,1,1,1,1,,1,,1,,,,,,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:12, name:'トランスフォームフロアブル', strain:'',classificationCode:'4C',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[1], memo:'',mixList:[0,,,,,,1,,,,,,,,,,,,,,,,,,,,1,,1,,,,,,1,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:13, name:'トルネードエースDF', strain:'',classificationCode:'22A',dilution:{min:null,max:2000},useTime:{type:1,value:'14'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[11,12], memo:'',mixList:[0,,1,,,,,,,,,,,,,,1,,,1,,,,,1,1,1,1,,1,,1,1,1,1,1,1,1,1,1,1,,,1,1,,1,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:14, name:'トレボン乳剤', strain:'',classificationCode:'3A',dilution:{min:1000,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,1,,,,,,,,,,,,,,,,,,,,1,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:15, name:'ノーモルト乳剤', strain:'',classificationCode:'15',dilution:{min:null,max:2000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[12], memo:'',mixList:[0,,,1,,1,,1,,,,,,,,,,,1,1,,,,1,,,1,1,1,1,,,1,1,,1,1,1,1,1,1,,,,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:16, name:'パダンSG水溶剤', strain:'',classificationCode:'14',dilution:{min:null,max:1500},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:4,sicks:[],vermins:[12], memo:'',mixList:[0,1,,,,1,,1,1,,1,,,1,,,,1,1,1,,,,1,1,,,1,,1,,,1,,,1,1,1,,,1,,,,1,,,,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:17, name:'フェニックス顆粒水溶剤', strain:'',classificationCode:'28',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[12,6,5,14], memo:'',mixList:[0,1,1,1,,1,,1,1,1,1,,,,,,1,,1,1,1,,,1,1,1,1,1,1,1,1,1,1,1,1,1,1,,1,,1,,,1,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:18, name:'プリンスフロアブル', strain:'',classificationCode:'2B',dilution:{min:null,max:2000},useTime:{type:1,value:'30'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[12,14], memo:'',mixList:[0,1,,1,,,,1,1,1,1,,,,,1,1,1,,,,,,1,,1,1,,1,1,1,,,1,,1,1,,,,1,,,1,1,,,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:19, name:'プレオフロアブル', strain:'',classificationCode:'UN',dilution:{min:null,max:1000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[12,5], memo:'',mixList:[0,1,,1,1,,,1,1,1,1,,,1,1,1,1,1,,,1,,,1,1,1,1,1,1,,1,1,1,1,1,1,1,,1,1,1,,,1,1,1,1,,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:20, name:'プレバソンフロアブル５', strain:'',classificationCode:'28',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12,5,14], memo:'',mixList:[0,1,,1,,1,,1,1,1,,,,,,,,1,,1,,,,,1,1,1,1,1,1,1,,1,1,1,1,1,1,1,1,1,,,,1,1,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:21, name:'ベストゴード水溶液', strain:'',classificationCode:'4A',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[1,2], memo:'',mixList:[0,,,,,,1,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:22, name:'ベネビアOD', strain:'',classificationCode:'28',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12,5,1,2], memo:'アブラムシ類・アザミウマ類は希釈倍率2000',mixList:[0,,,,,,,,,1,,,,,,,,,,,,,,1,,1,1,1,1,2,,,1,1,,,,,1,,,,,1,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:23, name:'モスピラン顆粒水和剤', strain:'',classificationCode:'4A',dilution:{min:null,max:2000},useTime:{type:1,value:'14'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[11,12,1,2], memo:'',mixList:[0,1,,1,1,1,1,1,1,,,,,,,1,1,1,1,1,,,1,,,1,1,1,,1,,,1,1,1,1,1,1,1,1,1,,,1,1,,1,,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:24, name:'モベントフロアブル', strain:'',classificationCode:'23',dilution:{min:2000,max:4000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[],vermins:[1,2], memo:'アザミウマ類は希釈倍率2000',mixList:[0,1,1,1,,1,1,1,,,1,1,,1,,,1,1,,1,1,,,,,1,1,1,1,1,1,,1,1,1,1,,1,,1,,,,,,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:25, name:'ランネート45DF', strain:'',classificationCode:'1A',dilution:{min:1000,max:2000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[6,1], memo:'ヨトウムシは希釈倍率1000',mixList:[0,1,1,,,1,1,,1,,,1,,1,,,,1,1,1,1,,1,1,1,,1,1,,1,,,1,,,1,1,1,1,1,1,,,,,,,,3,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:26, name:'アフェットフロアブル', strain:'',classificationCode:'7',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[1,7],vermins:[], memo:'',mixList:[0,,1,1,1,1,1,1,,1,1,1,,1,,1,,1,1,1,1,,1,1,1,1,,,1,,1,1,,1,1,1,,,,1,,,,1,,,,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:27, name:'アミスター２０フロアブル', strain:'',classificationCode:'11',dilution:{min:null,max:2000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[2,7],vermins:[], memo:'',mixList:[0,1,1,1,1,,1,1,1,1,1,1,,1,,1,1,1,,1,1,,1,1,1,1,,,,,,3,,1,,,1,1,,1,,,,1,,1,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:28, name:'カセット水和剤', strain:'',classificationCode:'24,31',dilution:{min:null,max:1000},useTime:{type:1,value:'21'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[3],vermins:[], memo:'',mixList:[0,1,,1,,1,1,1,1,1,1,,,,,1,,1,1,1,1,,1,,1,,1,,,,,,1,,,,1,1,1,,,,,1,1,,,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:29, name:'カンタスドライフロアブル', strain:'',classificationCode:'7',dilution:{min:1000,max:1500},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[1],vermins:[], memo:'',mixList:[0,1,,,,2,1,1,1,1,1,,,1,,1,1,1,1,,1,,2,1,1,1,,,,,1,,,2,,,,2,,,,,,1,,,,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:30, name:'キノンドー水和剤４０', strain:'',classificationCode:'M1',dilution:{min:null,max:800},useTime:{type:1,value:'14'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[3,5],vermins:[], memo:'',mixList:[0,1,1,1,,1,1,,1,,1,,,,,,,1,1,1,1,,,,1,,1,,,1,,,1,,,,1,1,,,1,,,,1,,1,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:31, name:'コサイド３０００', strain:'',classificationCode:'M1',dilution:{min:null,max:1000},useTime:{type:99,value:''},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[6],vermins:[], memo:'',mixList:[0,1,1,,1,,1,,1,,,1,,1,,,,1,,1,,,,,,,1,3,,,,,1,,,,1,2,1,,1,,,4,1,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:32, name:'シグナムWDG', strain:'',classificationCode:'11',dilution:{min:1500,max:2000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[1,2,7],vermins:[], memo:'菌核病・黒すす病は希釈倍率1500',mixList:[0,1,1,1,,2,1,1,1,1,1,1,,1,,1,1,1,,1,1,,1,1,1,1,,,1,,1,1,,1,3,,,,1,,,,,1,,,,1,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:33, name:'スターナ水和剤', strain:'',classificationCode:'31',dilution:{min:null,max:2000},useTime:{type:1,value:'14'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[4,5],vermins:[], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,1,,1,,1,,1,1,1,1,,1,1,1,,1,1,,2,,,1,,,1,1,1,1,1,1,,,1,1,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:34, name:'ダコニール１０００', strain:'',classificationCode:'M5',dilution:{min:null,max:1000},useTime:{type:99,value:'出蕾前但し、21日前'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[],vermins:[], memo:'',mixList:[0,1,1,,,,1,,1,,,1,,1,,,,1,,1,1,,,1,1,,1,,,,,,3,,,1,1,1,1,1,,,,1,,,,,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:35, name:'トップジンM水和剤', strain:'',classificationCode:'1',dilution:{min:null,max:2000},useTime:{type:1,value:'14'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[1],vermins:[], memo:'',mixList:[0,,1,1,,1,1,1,,,1,,,1,,1,1,1,1,1,1,,,1,1,1,1,,,,,,,1,1,,1,1,,,,,,1,1,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:36, name:'パレード２０フロアブル', strain:'',classificationCode:'7',dilution:{min:2000,max:4000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[1],vermins:[], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,1,,1,,1,1,1,1,1,1,,,1,,1,,1,1,,1,1,,1,1,1,,,,1,,,,,,1,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:37, name:'ピシロックフロアブル', strain:'',classificationCode:'U17',dilution:{min:null,max:1000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[2],vermins:[], memo:'',mixList:[0,,1,1,,2,1,1,1,1,1,,,1,,1,1,,,,1,,,1,1,1,,1,1,2,1,2,,1,1,1,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:38, name:'ファンタジスタ顆粒水和剤', strain:'',classificationCode:'11',dilution:{min:null,max:3000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[1],vermins:[], memo:'',mixList:[0,1,1,1,,,1,1,,,1,1,,1,,1,,1,,1,1,,1,1,,1,,,1,,,1,1,1,1,,,,,,,,,,,1,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:39, name:'フェリオゴールド', strain:'',classificationCode:'4,M5',dilution:{min:null,max:1000},useTime:{type:99,value:'出蕾前但し、21日前'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[2],vermins:[], memo:'',mixList:[0,,,1,,1,1,1,,1,1,,,1,1,1,,,,1,1,,,1,1,1,1,1,,,,,,1,1,,1,,,,,,,1,1,,,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:40, name:'ベジセイバー', strain:'',classificationCode:'7,M5',dilution:{min:null,max:1000},useTime:{type:99,value:'出蕾前但し、21日前'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[1,2],vermins:[], memo:'',mixList:[0,1,1,1,,1,1,1,,1,1,,,1,,1,1,1,1,1,1,,,1,,1,,,,,1,1,,1,,,,,,,,,,,,1,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:41, name:'ベンレート水和剤', strain:'',classificationCode:'1',dilution:{min:2000,max:4000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[1],vermins:[], memo:'',mixList:[0,,,,,,4,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,1,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:42, name:'ホライズンドライフロアブル', strain:'',classificationCode:'11,27',dilution:{min:null,max:2500},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[2],vermins:[], memo:'',mixList:[0,,,,,,1,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:43, name:'マスタピース水和剤', strain:'',classificationCode:'',dilution:{min:1000,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[4,5,6],vermins:[], memo:'',mixList:[0,1,1,,,,,1,,,,,,1,,,,1,1,1,,,1,1,,,1,1,1,1,,4,1,1,1,1,,,,1,,1,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:44, name:'メジャーフロアブル', strain:'',classificationCode:'11',dilution:{min:null,max:2000},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[1,2],vermins:[], memo:'',mixList:[0,1,1,1,4,1,,1,1,1,1,1,,1,,1,1,1,1,1,1,,1,1,,,,,1,,1,1,,1,,1,,,,1,,,,,,,1,1,1,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:45, name:'ヨネポン水和剤', strain:'',classificationCode:'M1',dilution:{min:null,max:500},useTime:{type:1,value:'1'},prevarication:{unit:null, min:null,max:null},useLimitNum:4,sicks:[2,3],vermins:[], memo:'',mixList:[0,1,,,,,4,,1,,1,,,,,,,,,1,1,,,,,,,1,,,,,,,,,1,,1,,1,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:46, name:'ライメイフロアブル', strain:'',classificationCode:'21',dilution:{min:2000,max:3000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:4,sicks:[2],vermins:[], memo:'',mixList:[0,1,1,1,,,1,1,1,1,1,1,,1,,1,,1,,1,1,,1,1,1,,,,,,1,,,1,,,1,,1,,,,1,,1,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:47, name:'ランマンフロアブル', strain:'',classificationCode:'21',dilution:{min:null,max:2000},useTime:{type:1,value:'3'},prevarication:{unit:null, min:null,max:null},useLimitNum:3,sicks:[2],vermins:[], memo:'',mixList:[0,1,1,1,1,1,1,1,1,1,1,1,,,,1,,1,1,,1,,1,,1,,1,,1,1,1,,1,1,,,1,,1,1,,,1,,1,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:48, name:'レーバスフロアブル', strain:'',classificationCode:'40',dilution:{min:null,max:2000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:2,sicks:[2],vermins:[], memo:'',mixList:[0,,1,1,,1,1,1,1,1,1,1,,,,1,1,1,1,1,1,,1,1,1,3,1,,,,,,,1,1,,1,,1,1,,,1,,1,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:100, name:'*プレバソンフロアブル５', strain:'',classificationCode:'28',dilution:{min:null,max:100},useTime:{type:99,value:'育苗期後半～定植当日'},prevarication:{unit:null, min:null,max:null},useLimitNum:1,sicks:[],vermins:[11,12,5], memo:'セルトレイ当たり0.5L',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:101, name:'*ベリマークSC', strain:'',classificationCode:'28',dilution:{min:null,max:400},useTime:{type:99,value:'育苗期後半～定植当日'},prevarication:{unit:null, min:null,max:null},useLimitNum:1,sicks:[],vermins:[11,12,5,14,1,2], memo:'セルトレイ当たり0.5L',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:102, name:'*ダコニール１０００', strain:'',classificationCode:'M5',dilution:{min:null,max:1000},useTime:{type:99,value:'定植時'},prevarication:{unit:null, min:null,max:null},useLimitNum:1,sicks:[8],vermins:[], memo:'',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:103, name:'*ミネクトデュオ粒剤', strain:'',classificationCode:'28',dilution:{min:null,max:null},useTime:{type:99,value:'定植時、播種時'},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[],vermins:[11,12,6,5,14,1,2], memo:'定植時:株元散布1g/株。播種時:セルトレイ1箱またはペーパーポット1冊当たり40g',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:104, name:'*ランマンフロアブル', strain:'',classificationCode:'21',dilution:{min:null,max:500},useTime:{type:99,value:'定植前日～当日'},prevarication:{unit:null, min:null,max:null},useLimitNum:1,sicks:[8],vermins:[], memo:'セルトレイ当たり2L',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:105, name:'*リゾレックス水和剤', strain:'',classificationCode:'14',dilution:{min:null,max:500},useTime:{type:99,value:'育苗期:2回、収穫21日前:1回'},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[],vermins:[], memo:'苗立枯病(リゾクトニア菌) 3L/m2',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                    {version:'1.0.0', target:2, agrichemicalNo:106, name:'*ライメイフロアブル', strain:'',classificationCode:'21',dilution:{min:null,max:2000},useTime:{type:1,value:'7'},prevarication:{unit:null, min:null,max:null},useLimitNum:0,sicks:[2],vermins:[], memo:'土壌混和2回、灌注1回',mixList:[0,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,]},
                ]
                for (var i=0; i<items.length; i++) {
                    const mixList = {}
                    for (var j=1; j<items[i].mixList.length; j++) {
                        if (items[i].mixList[j] == null) {
                            // mixList[j] = 0
                        } else {
                            mixList[j] = items[i].mixList[j]
                        }
                    }
                    items[i].mixList = mixList
                    db.collection("system").doc("template").collection("agrichemicals").doc(items[i].target+"").collection("items").doc(items[i].agrichemicalNo+"").set(items[i])
                }
            },
            // onClickWork6: function () {
            //     db.collection("system").doc("area").collection("list").get().then(function(refAreas){
            //         refAreas.forEach(function(refArea){
            //             const area = refArea.data()
            //             db.collection("areas").doc(area.area).set(area).then(function(){
            //                 console.log("area copied", area)
            //             })
            //         })
            //     })
            // },
            // 所属グループのID変更処理
            // onClickWork1: function () {
            //     db.collection("users").get().then(function(users){
            //         users.forEach(function(docUser){
            //             const user = docUser.data()
            //             console.log("find", user.userUID, user.userName)
            //             db.collection("users").doc(user.userUID).collection("belong_groups").get().then(function(groups){
            //                 if (groups.size == 0) {
            //                     console.log("no belong groups", user.userUID, user.userName)
            //                 } else {
            //                     console.log("belong group num", user.userUID, user.userName, groups.size)
            //                 }
            //                 groups.forEach(function(docGroup){
            //                     try{
            //                         const group = docGroup.data()
            //                         console.log("belong group", user.userUID, user.userName, group)
            //                         if (docGroup.id.indexOf(group.owner.userUID) == -1) {
            //                             console.log("group id change target", user.userUID, user.userName, group.owner.userUID, docGroup.id)
            //                             db.collection("users").doc(user.userUID).collection("belong_groups").doc(group.owner.userUID+"-"+group.groupNo).set(group).then(function(){
            //                                 console.log("group id change success")
            //                             })
            //                         } else {
            //                             console.log("group id no change", user.userUID, user.userName, group.owner.userUID, docGroup.id)
            //                         }
            //                     } catch (error) {
            //                         console.log(error)
            //                     }
            //                 })
            //             }).catch (function(error) {
            //                 console.log(error)
            //             })
            //         })
            //     }).catch (function(error){
            //         console.log(error)
            //     })
            // },
            // ユーザー情報にシステム通知に関するフィールドを追加
            // onClickWork2: function () {
            //     db.collection("users").get().then(function(users){
            //         users.forEach(function(docUser){
            //             const user = docUser.data()
            //             user.systemNotification = {
            //                 lastDateTime: ""
            //             }
            //             db.collection("users").doc(user.userUID).set(user).then(function(){
            //                 console.log("success", user)
            //             }).catch(function(error){
            //                 console.log("failed", user, error)
            //             })
            //         })
            //     }).catch (function(error){
            //         console.log(error)
            //     })
            // },
            // 栽培区分のテンプレート追加
            // onClickWork3: function () {
            //     const templates = [
            //         {type: 1, name:"露地栽培"},
            //         {type: 2, name:"ハウス栽培"},
            //         {type: 3, name:"水耕栽培"},
            //         {type: 4, name:"促成栽培"},
            //         {type: 5, name:"原木栽培"},
            //         {type: 6, name:"早期栽培"},
            //         {type: 7, name:"不耕起栽培"},
            //         {type: 8, name:"有機栽培"},
            //         {type: 9, name:"無農薬栽培"},
            //         {type: 10, name:"養液栽培"},
            //         {type: 11, name:"有機養液栽培"},
            //         {type: 12, name:"抑制栽培"},
            //         {type: 13, name:"菌床栽培"},
            //         {type: 14, name:"マルチ栽培"},
            //         {type: 15, name:"トロ箱栽培"},
            //         {type: 16, name:"ブドウ栽培"},
            //         {type: 17, name:"草生栽培"},
            //         {type: 18, name:"工場栽培"},
            //         {type: 19, name:"半栽培"},
            //     ]

            //     const base = db.collection("system").doc("template").collection("cultivation_types")
                
            //     templates.forEach(function(t){
            //         const cultivation = {
            //             version: "1.0.0",
            //             type: t.type,
            //             name: t.name,
            //             register: {
            //                 userUID: "",
            //                 dateTime: ""
            //             }
            //         }
            //         base.doc(cultivation.type + "").set(cultivation)
            //     })
            // },
            // 場所作業項目等のテンプレート追加
            // onClickWork4: function () {
            // //     // 堆肥
            // //     const composts = [
            // //         {
            // //             categoryID: 1,
            // //             name: "植物性",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "腐葉土"
            // //                 },
            // //                 {
            // //                     id: 2,
            // //                     name: "ワラ"
            // //                 },
            // //                 {
            // //                     id: 3,
            // //                     name: "バーク"
            // //                 },
            // //                 {
            // //                     id: 4,
            // //                     name: "もみ殻"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 2,
            // //             name: "動物性",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "鶏ふん"
            // //                 },
            // //                 {
            // //                     id: 2,
            // //                     name: "牛ふん"
            // //                 },
            // //                 {
            // //                     id: 3,
            // //                     name: "豚ふん"
            // //                 },
            // //                 {
            // //                     id: 4,
            // //                     name: "馬ふん"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 100,
            // //             name: "その他",
            // //             items: [
            // //             ]
            // //         }
            // //     ]
            // //     composts.forEach(function(compost){
            // //         compost.register = {
            // //             userUID: "",
            // //             dateTime: ""
            // //         }
            // //         db.collection("system").doc("template").collection("composts").doc(compost.categoryID+"").set(compost).then(function(){
            // //             console.log("compost registered", compost)
            // //         })
            // //     })

            // //     // 肥料
            // //     const fertilizeries = [
            // //         {
            // //             categoryID: 1,
            // //             name: "有機質",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "魚かす"
            // //                 },
            // //                 {
            // //                     id: 2,
            // //                     name: "油かす"
            // //                 },
            // //                 {
            // //                     id: 3,
            // //                     name: "発行油かす"
            // //                 },
            // //                 {
            // //                     id: 4,
            // //                     name: "鶏ふん"
            // //                 },
            // //                 {
            // //                     id: 5,
            // //                     name: "骨粉"
            // //                 },
            // //                 {
            // //                     id: 6,
            // //                     name: "草木灰"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 2,
            // //             name: "無機質肥料",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "無機質肥料"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 3,
            // //             name: "複合肥料",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "複合肥料"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 4,
            // //             name: "液肥",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "液肥"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 5,
            // //             name: "置肥",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "置肥"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 100,
            // //             name: "その他",
            // //             items: [
            // //             ]
            // //         }
            // //     ]
            // //     fertilizeries.forEach(function(item){
            // //         item.register = {
            // //             userUID: "",
            // //             dateTime: ""
            // //         }
            // //         db.collection("system").doc("template").collection("fertilizeries").doc(item.categoryID+"").set(item).then(function(){
            // //             console.log("fertilizer registered", item)
            // //         })
            // //     })

            // //     // 農薬
            // //     const pesticides = [
            // //         {
            // //             categoryID: 1,
            // //             name: "殺虫殺菌剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "殺虫殺菌剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 2,
            // //             name: "殺虫剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "殺虫剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 3,
            // //             name: "殺ダニ剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "殺ダニ剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 4,
            // //             name: "殺線虫剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "殺線虫剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 5,
            // //             name: "なめくじ駆除剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "なめくじ駆除剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 6,
            // //             name: "殺菌剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "殺菌剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 7,
            // //             name: "除草剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "除草剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 8,
            // //             name: "植物成長調整剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "植物成長調整剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 9,
            // //             name: "展着剤",
            // //             items: [
            // //                 {
            // //                     id: 1,
            // //                     name: "展着剤"
            // //                 },
            // //             ]
            // //         },
            // //         {
            // //             categoryID: 100,
            // //             name: "その他",
            // //             items: [
            // //             ]
            // //         }
            // //     ]
            // //     pesticides.forEach(function(item){
            // //         item.register = {
            // //             userUID: "",
            // //             dateTime: ""
            // //         }
            // //         db.collection("system").doc("template").collection("pesticides").doc(item.categoryID+"").set(item).then(function(){
            // //             console.log("pesticide registered", item)
            // //         })
            // //     })

            //     // 場所作業
            //     const workTypes = [
            //         {
            //             workTypeID: 1,
            //             name: "堆肥",
            //             recordItems: [
            //                 {
            //                     recordNo: 1,
            //                     orderNo: 1,
            //                     type: 7,
            //                     name: "使用堆肥",
            //                     isRequired: true,
            //                 },
            //                 {
            //                     recordNo: 2,
            //                     orderNo: 2,
            //                     type: 1,
            //                     name: "使用量",
            //                     isRequired: true,
            //                     data: {
            //                         min: 0
            //                     }
            //                 },
            //             ],
            //         },
            //         {
            //             workTypeID: 2,
            //             name: "散水",
            //             recordItems: [
            //                 {
            //                     recordNo: 1,
            //                     orderNo: 1,
            //                     type: 1,
            //                     name: "散水量",
            //                     isRequired: true
            //                 },
            //                 {
            //                     recordNo: 2,
            //                     orderNo: 2,
            //                     type: 4,
            //                     name: "散水開始時刻",
            //                     isRequired: true
            //                 },
            //                 {
            //                     recordNo: 3,
            //                     orderNo: 3,
            //                     type: 4,
            //                     name: "散水終了時刻",
            //                     isRequired: true
            //                 },
            //             ],
            //         },
            //         {
            //             workTypeID: 3,
            //             name: "肥料散布",
            //             recordItems: [
            //                 {
            //                     recordNo: 1,
            //                     orderNo: 1,
            //                     type: 8,
            //                     name: "散布肥料",
            //                     isRequired: true
            //                 },
            //                 {
            //                     recordNo: 2,
            //                     orderNo: 2,
            //                     type: 1,
            //                     name: "散布量",
            //                     isRequired: true,
            //                     data: {
            //                         min: 0
            //                     }
            //                 },
            //             ],
            //         },
            //         {
            //             workTypeID: 4,
            //             name: "農薬散布",
            //             recordItems: [
            //                 {
            //                     recordNo: 1,
            //                     orderNo: 1,
            //                     type: 9,
            //                     name: "散布農薬",
            //                     isRequired: true
            //                 },
            //                 {
            //                     recordNo: 2,
            //                     orderNo: 2,
            //                     type: 1,
            //                     name: "散布量",
            //                     isRequired: true,
            //                     data: {
            //                         min: 0
            //                     }
            //                 },
            //             ],
            //         },
            //         {
            //             workTypeID: 5,
            //             name: "観察",
            //             recordItems: [
            //             ],
            //         },
            //         {
            //             workTypeID: 6,
            //             name: "収穫",
            //             recordItems: [
            //             ],
            //         },
            //         {
            //             workTypeID: 7,
            //             name: "定植",
            //             recordItems: [
            //             ],
            //         },
            //     ]
            //     workTypes.forEach(function(item){
            //         item.register = {
            //             userUID: "",
            //             dateTime: ""
            //         },
            //         db.collection("system").doc("template").collection("place_work_types").doc(item.workTypeID+"").set(item).then(function(){
            //             console.log("work type registered", item)
            //         })
            //     })
            // },
        }
    }
</script>